"use client"
import styles from "@css/modules/Layout.module.scss"
import { MailIcon } from "@css/icons/SVG"
import { LongArrowDown } from "@css/icons/LongArrowDown"
import { FormEvent, useState } from "react"
import { SlideAppear } from "../../Animation/SlideAppear"
import { message } from "@components/Message/message"

interface Elements extends HTMLFormControlsCollection {
    email: HTMLInputElement
}

export function Subscribe() {
    const [sent, setSent] = useState(false)
    const [loading, setLoading] = useState(false)
    const onSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        setLoading(true)
        const elements = event.currentTarget.elements as Elements

        const url = `https://a.klaviyo.com/client/subscriptions?company_id=${process.env.NEXT_PUBLIC_KLAVIYO_SITE_ID}`
        const options = {
            method: "POST",
            headers: {
                accept: "application/vnd.api+json",
                revision: "2025-04-15",
                "content-type": "application/vnd.api+json"
            },
            body: JSON.stringify({
                data: {
                    type: "subscription",
                    attributes: {
                        profile: {
                            data: {
                                type: "profile",
                                attributes: {
                                    email: elements.email.value,
                                    subscriptions: {
                                        email: { marketing: { consent: "SUBSCRIBED" } }
                                    }
                                }
                            }
                        },
                        custom_source: "Homepage footer signup form"
                    },
                    relationships: { list: { data: { type: "list", id: process.env.KLAVIYO_USERS_LIST_ID } } }
                }
            })
        }

        fetch(url, options)
            .catch((err) => {
                console.log(err)
                message.warning("Submitting error occurred")
            })
            .finally(() => {
                setLoading(false)
                setSent(true)
            })
    }

    return (
        <SlideAppear className={styles.subscribeSection}>
            {sent ? (
                <div className={styles.thank}>Thank you for subscription!</div>
            ) : (
                <>
                    <h3>Sign up for weekly updates</h3>
                    <h4>Don’t miss our new offers and keep up to date.</h4>
                    <form className={styles.form} onSubmit={onSubmit}>
                        <label>
                            <MailIcon />
                            <input type="email" placeholder="example@gmail.com" name="email" required />
                        </label>
                        <button disabled={loading} type="submit" className={styles.btnFilled} aria-label="Sign me Up">
                            <span className={styles.btnText}>Sign me Up</span>
                            <LongArrowDown />
                        </button>
                    </form>
                </>
            )}
        </SlideAppear>
    )
}
